// Score-related constants
export const SCORE_TYPES = {
  TOTAL: 'total',
  CLUB: 'club',
  NATIONAL_TEAM: 'national_team',
} as const;

// Score display names
export const SCORE_DISPLAY_NAMES = {
  [SCORE_TYPES.TOTAL]: 'Use All Scores',
  [SCORE_TYPES.CLUB]: 'Use Club Scores',
  [SCORE_TYPES.NATIONAL_TEAM]: 'Use National Team Scores',
};

// Score column titles
export const SCORE_COLUMN_TITLES = {
  [SCORE_TYPES.CLUB]: 'Club',
  [SCORE_TYPES.NATIONAL_TEAM]: 'National Team',
};

// Default score type
export const DEFAULT_SCORE_TYPE = SCORE_TYPES.TOTAL;
